import * as Actions from './SessionSurveyActions';

const initialState = {
  fetching: false,
  surveys: [],
  error: null
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case Actions.GET_SESSION_SURVEY_REQUEST: {
      return { ...state, fetching: true };
    }
    case Actions.GET_SESSION_SURVEY_SUCCESS: {
      const { surveys } = action.payload;
      return {
        ...state,
        surveys,
        fetching: false,
        error: null
      };
    }
    case Actions.GET_SESSION_SURVEY_FAILURE: {
      return { ...state, error: action.error, fetching: false };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/Reducks/SessionSurvey/SessionSurveyReducer.js